import Types from './Types';

export const getAllAssistantsRequest = (body) => ({
    type: Types.GET_ALL_ASSISTANTS_REQUEST,
    payload: body
});

export const getAllAssistantsSuccess = (data) => ({
    type: Types.GET_ALL_ASSISTANTS_SUCCESS,
    payload: data
});

export const getAllAssistantsFail = () => ({
    type: Types.GET_ALL_ASSISTANTS_FAIL
});

export const editAssistantRequest = (formData, action) => ({
    type: Types.EDIT_ASSISTANT_REQUEST,
    payload: formData,
    action: action
});

export const editAssistantSuccess = (data) => ({
    type: Types.EDIT_ASSISTANT_SUCCESS,
    payload: data
});

export const editAssistantFail = () => ({
    type: Types.EDIT_ASSISTANT_FAIL
});

//LOADING
export const addAssistantsLoading = (isLoading) => ({
    type: Types.ADD_ASSISTANTS_LOADING,
    payload: isLoading
});

// Create Assistant
export const createAssistantRequest = (formData, action) => ({
    type: Types.CREATE_ASSISTANT_REQUEST,
    payload: formData,
    action: action
});

export const createAssistantSuccess = ({ data }) => ({
    type: Types.CREATE_ASSISTANT_SUCCESS,
    payload: {
        data
    }
});

export const createAssistantFail = () => ({
    type: Types.CREATE_ASSISTANT_FAIL
});

export const deleteAssistantRequest = (id) => ({
    type: Types.DELETE_ASSISTANT_REQUEST,
    payload: id
});

export const deleteAssistantSuccess = (id) => ({
    type: Types.DELETE_ASSISTANT_SUCCESS,
    payload: id
});

export const deleteAssistantFail = () => ({
    type: Types.DELETE_ASSISTANT_FAIL
});

export const suspendAssistantRequest = (id, reason) => ({
    type: Types.SUSPEND_ASSISTANT_REQUEST,
    payload: { id, reason }
});

export const suspendAssistantSuccess = (data) => ({
    type: Types.SUSPEND_ASSISTANT_SUCCESS,
    payload: data
});

export const suspendAssistantFail = () => ({
    type: Types.SUSPEND_ASSISTANT_FAIL
});

